import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { localizedPath, pick } from "@/lib/helpers";
import { mediaUrl } from "@/lib/api";

export function ServiceCard({ service: s, testIdPrefix = "service-card" }) {
  const { lang = "en" } = useParams();
  const { t } = useTranslation();
  const slug = lang === "fr" ? s.slugFr : s.slugEn;
  return (
    <Link
      to={localizedPath(lang, `/services/${slug}`)}
      className="group glass-card block h-full hover:-translate-y-1 hover:shadow-[0_0_24px_rgba(0,212,255,0.15)]"
      data-testid={`${testIdPrefix}-${s.slugEn}`}
    >
      <div className="overflow-hidden aspect-[4/3]">
        <img
          src={mediaUrl(s.cardImage || s.heroImage, { w: 600, fmt: "webp", q: 78 })}
          alt={pick({ en: s.titleEn, fr: s.titleFr }, lang)}
          loading="lazy"
          decoding="async"
          width="600"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <div className="eyebrow mb-2">{pick({ en: s.eyebrowEn, fr: s.eyebrowFr }, lang)}</div>
        <h3 className="font-display font-bold uppercase text-fg text-xl tracking-wide">
          {pick({ en: s.titleEn, fr: s.titleFr }, lang)}
        </h3>
        <p className="mt-3 text-mut text-sm leading-relaxed line-clamp-3">
          {pick({ en: s.summaryEn, fr: s.summaryFr }, lang)}
        </p>
        <span className="mt-4 inline-flex items-center gap-1 text-accent font-techmono text-xs uppercase tracking-widest">
          {t("cta.learnMore")} <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}
